import React from 'react'

export interface CheckoutOptionsContextValue {
  payment?: {
    onlyIntegration?: boolean
  }
}

export default React.createContext<CheckoutOptionsContextValue>({})
